import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';
import store from '../../../../store/index';
import { resolveTierAccess } from '../../../../helper/subscriptionHelper';

const routerGuard = async (to, from, next) => {
  const accountId = to.params.accountId;
  const { hasAccess, hasError } = await resolveTierAccess(store, accountId);

  if (hasError) {
    return next({
      name: 'subscription_error',
      params: { accountId },
      query: { redirect: to.fullPath },
    });
  }

  if (!hasAccess) {
    return next({ name: 'general_settings_index' });
  }

  return next();
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/module'),
      component: Index,
      name: 'module',
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: routerGuard,
    },
  ],
};
